import { render, staticRenderFns } from "./PersonalCenter.vue?vue&type=template&id=12d16a25&scoped=true&"
import script from "./PersonalCenter.vue?vue&type=script&lang=js&"
export * from "./PersonalCenter.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCenter.vue?vue&type=style&index=0&id=12d16a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d16a25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d16a25')) {
      api.createRecord('12d16a25', component.options)
    } else {
      api.reload('12d16a25', component.options)
    }
    module.hot.accept("./PersonalCenter.vue?vue&type=template&id=12d16a25&scoped=true&", function () {
      api.rerender('12d16a25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/PersonalCenter.vue"
export default component.exports